import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { CryptoVaultService } from 'src/app/shared/services/external/crypto-vault/crypto-vault.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';
import { CHANNEL as CHANNEL_CONSTANS } from '../../../../shared/constants/channel.constants';
var RequestLoanComponent = /** @class */ (function () {
    function RequestLoanComponent(headerService, copyService, bitacoraService, navigationService, abreCuentasService, requestService, cipherService) {
        this.headerService = headerService;
        this.copyService = copyService;
        this.bitacoraService = bitacoraService;
        this.navigationService = navigationService;
        this.abreCuentasService = abreCuentasService;
        this.requestService = requestService;
        this.cipherService = cipherService;
        this.data = this.abreCuentasService
            .getProductsSelects()
            .find(function (s) { return s.flow === 'freeInvestment2' || 'loan'; }).name;
        this.isBtnDisabled = true;
        this.listRequestLoan = this.validateProduct();
        this.headerService.show(true, true, true);
    }
    RequestLoanComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.abreCuentasService.getPostlogin()) {
            this.clientProduct();
        }
        this.selectedData = this.abreCuentasService.getRequestLoanSelected();
        if (this.abreCuentasService.getRequestLoanSelected() && this.abreCuentasService.getRequestLoanSelected().elementId) {
            this.listRequestLoan = this.listRequestLoan === undefined ? [] : this.listRequestLoan.map(function (item) { return ({
                description: item.description,
                elementId: item.elementId,
                checked: _this.selectedData.elementId === item.elementId,
            }); });
            console.log(this.listRequestLoan);
            this.isBtnDisabled = false;
        }
    };
    RequestLoanComponent.prototype.validateProduct = function () {
        var products = [{
                description: this.data + ' ' + this.copyService.copies.request_loan_radio1,
                elementId: '01',
                checked: false,
            }];
        if (this.abreCuentasService.haveLoan) {
            products.push({
                description: this.data + ' ' + this.copyService.copies.request_loan_radio2,
                elementId: '02',
                checked: false,
            });
        }
        return products;
    };
    RequestLoanComponent.prototype.selectRequestLoan = function (event) {
        this.isBtnDisabled = false;
        this.selectedData = event;
    };
    RequestLoanComponent.prototype.clientProduct = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requestService.clientProduct().then(function (res) {
                            res.body.data.forEach(function (record) {
                                console.log(_this.cipherService.decrypt(record.product_type));
                                console.log(_this.cipherService.decrypt(record.product_number));
                                console.log(_this.cipherService.decrypt(record.product_sub_type));
                            });
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RequestLoanComponent.prototype.next = function () {
        this.abreCuentasService.setProductDestinationType(this.selectedData.elementId === '01' ? '00' : undefined);
        this.abreCuentasService.setRequestLoanSelected(this.selectedData);
        if (this.selectedData.elementId === '01') {
            this.bitacoraService.saveDataInBitacora('Payroll_without_Purchase');
            this.navigationService.nextStep('200');
        }
        else {
            this.bitacoraService.saveDataInBitacora('Payroll_with_Purchase');
            this.abreCuentasService.chanelid === CHANNEL_CONSTANS.PORTALO.CODE ?
                this.navigationService.nextStep('203') : this.abreCuentasService.getPostlogin() ?
                this.navigationService.nextStep('202') : this.navigationService.nextStep('201');
        }
    };
    return RequestLoanComponent;
}());
export { RequestLoanComponent };
